export const ACCESS_DENIED = 'ACCESS_DENIED';
export const API_FILE_REQUEST = 'API_FILE_REQUEST';
export const API_REQUEST = 'API_REQUEST';
export const UNAUTHORIZED = 'UNAUTHORIZED';
